<div
  *ngIf="isVisible"
  class="popup-overlay d-flex justify-content-center align-items-center"
>
  <div class="popup-container">
    <div class="popup-header d-flex align-items-center">
      <h4 class="popup-title mb-0">{{ title | translate }}</h4>
      <button class="btn-close" (click)="cancelAction()">×</button>
    </div>

    <div class="text-center popup-body">
      <p>
        <span *ngIf="message.startsWith('Sorry!')" class="red-text"
          >{{ "common.sorry" | translate }}</span
        >
        {{ message.replace("Sorry! ", "") | translate }}
      </p>
    </div>

    <div class="d-flex justify-content-between">
      <button class="btn cancel-button" (click)="cancelAction()">{{'buttons.cancel'| translate}}</button>
      <button
        class="btn"
        [ngClass]="{
          'edit-button': actionButtonLabel === 'Edit Parent Entity',
          'delete-button': actionButtonLabel !== 'Edit Parent Entity'
        }"
        (click)="performAction()"
      >
        {{ actionButtonLabel | translate }}
      </button>
    </div>
  </div>
</div>
